import { resources } from "@/mocks/home";

export default function ResourceList() {
  return (
    <section id="resource" className="w-full bg-background-100/70 py-12 md:py-16">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="max-w-2xl">
          <p className="font-label text-xs font-semibold uppercase tracking-[0.2em] text-accent-700">资源入口</p>
          <h2 className="mt-2 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
            想一次性带走？这里就是深挖资源的集中入口
          </h2>
          <p className="mt-3 font-body text-sm text-foreground-600">
            把分散的深挖专题、时间线与独家爆料整理成可打包、可直达的资源，下载入口放在最醒目的位置。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-3">
          {resources.map((r) => (
            <a
              key={r.title}
              href="#tip"
              className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-200 hover:bg-primary-50/40"
            >
              <div className="flex items-start justify-between">
                <span className="flex h-12 w-12 items-center justify-center rounded-md bg-background-100 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={`${r.icon} text-xl`} />
                </span>
                <span className="whitespace-nowrap rounded-full bg-secondary-100 px-2 py-0.5 font-label text-[11px] text-secondary-900">
                  {r.size}
                </span>
              </div>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{r.title}</h3>
              <p className="mt-1.5 flex-1 font-body text-sm leading-relaxed text-foreground-600">{r.desc}</p>
              <span className="mt-4 inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 font-label text-sm font-semibold text-background-50 transition-colors group-hover:bg-primary-600">
                <i className="ri-download-2-line text-base leading-none" />
                {r.action}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}